import { render, staticRenderFns } from "./social-card.vue?vue&type=template&id=ffda82ba&scoped=true"
import script from "./social-card.vue?vue&type=script&lang=js"
export * from "./social-card.vue?vue&type=script&lang=js"
import style0 from "./social-card.vue?vue&type=style&index=0&id=ffda82ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffda82ba",
  null
  
)

export default component.exports